import { registrationForm } from "./registration-form";
import { words } from "./words";
import { splashScreens } from "./splash-screen";
import { splashScreenStyles } from "./splash-screen-style";
import { gameOverScreen } from "./game-over-screen";
import { gameButtons } from "./game-buttons";
import { marketPlace } from "./market-place";
import { settings } from "./settings";
import { profile } from "./profile";
import { messages } from "./messages";
import { languagesResources } from "./languages";
import { socialLogins } from "./social-logins";
import { sounds } from "./sounds";
import { ratings } from "./ratings";
import { icons } from "./icons";
import { rewardPoints } from "./reward-points";
import { generalSettings } from "./general-settings";
import { mockImages } from "./six-player-mock-images";
import { mockPrize } from "./mock-prize";
import { backgroundColor } from "./background-color";
import { mockGameLogo } from "./mock-game-logo";
import { numbers } from "./numbers";

let allResources: any = {
  generalSetting: generalSettings,
  rewardPoints: rewardPoints,
  icons: icons,
  numbers: numbers,
  ratings: ratings,
  sounds: sounds,
  socialLogins: socialLogins,
  // language data will be set in the end after everything is finalized
  language: languagesResources,
  messages: messages,
  profile: profile,
  settings: settings,
  marketplace: marketPlace,
  gameButtons: gameButtons,
  words: words,
  registrationForm: registrationForm,
  gameOverScreen: gameOverScreen,
  splashScreens: splashScreens,
  splashScreenStyles: splashScreenStyles,
  categories: [],
  mockImages: mockImages,
  mockPrize: mockPrize,
  backgroundColor: backgroundColor,
  mockGameLogo: mockGameLogo,
};

export { allResources };
